import { ChangeEventHandler, FC, useCallback, useRef } from 'react';

import {
  Button,
  ButtonProps,
} from '@beeline/design-system-react/extracted-styles';

import { TooltipWrapper } from '../TooltipWrapper/TooltipWrapper';

import classes from './UploadButton.module.scss';

export interface UploadButtonProps extends Omit<ButtonProps, 'onClick'> {
  onUpload: ChangeEventHandler<HTMLInputElement>;
  multiple?: boolean;
}

export const UploadButton: FC<UploadButtonProps> = ({
  onUpload,
  multiple = false,
  children,
  ...rest
}) => {
  const inputRef = useRef<HTMLInputElement | null>(null);

  const handleClick = useCallback(() => {
    if (inputRef.current) inputRef.current.click();
  }, []);

  return (
    <>
      <input
        type='file'
        ref={inputRef}
        className={classes.input}
        multiple={multiple}
        onChange={onUpload}
      />
      <TooltipWrapper title='Загрузить план'>
        <Button onClick={handleClick} {...rest}>
          {children}
        </Button>
      </TooltipWrapper>
    </>
  );
};
